import styled, { css } from 'styled-components'
import Box from 'components/shared/Box'
import { respondAbove } from 'styles/mediaQueries'

interface UploaderWrapperProps {
    isVisible: boolean
}

export const UploaderWrapper = styled(Box)<UploaderWrapperProps>`
    height: 100%;
    @media ${respondAbove.xl} {
        width: 286px;
    }

    ${({ isVisible }) =>
        !isVisible &&
        css`
            width: 0;
            height: 0;
            margin-right: 0;
            opacity: 0;
            overflow: hidden;

            @media ${respondAbove.xl} {
                width: 0;
            }
        `}

    & label {
        cursor: pointer;
    }

    & input {
        display: none;
    }
`
